var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-preloader"},[_c('img',{attrs:{"src":require("@/assets/graphics/app-preloader.svg"),"alt":""}})])
}]

export { render, staticRenderFns }